/**
 * Utility helper to determine if a feature is accessible for a user
 * based on their active subscription package and allowedFeatures configuration from DB.
 */
export const isFeaturePermitted = (profile, featureKey, requireActiveSubOnly = false) => {
  if (!profile) return false;

  // 1. Admin roles always have unrestricted access
  const role = (profile.role || "").toLowerCase();
  if (role.includes("admin")) return true;

  // 2. Check active subscription status
  const activeSub = profile.activeSubscription;
  const isSubActive = activeSub && 
    (activeSub.status === "Active" || activeSub.status === "Approved") &&
    (new Date(activeSub.endDate) > new Date() || (typeof activeSub.daysLeft === "number" && activeSub.daysLeft > 0));

  if (!isSubActive) return false;
  if (requireActiveSubOnly) return true;
  if (!featureKey) return true;

  // 3. Check allowedFeatures array returned from backend
  const allowedFeatures = activeSub.allowedFeatures || profile.allowedFeatures;
  if (Array.isArray(allowedFeatures)) {
    return allowedFeatures.includes(featureKey);
  }

  return false;
};
